import { FormControl } from '@angular/forms';
import { ParameterType } from '@src/api/reports';

export interface FormDataType {
  type: UIType;
  id: string;
  label: string;
  placeholder: string | null;
  order: number;
  visible: boolean;
}

export interface FormType {
  type: FormControl<UIType>;
  id: FormControl<string>;
  label: FormControl<string>;
  placeholder: FormControl<string | null>;
  order: FormControl<number>;
  visible: FormControl<boolean>;
}

export type UIType = ParameterType;
export const UIType = ParameterType;
